import { useMemo, useState } from 'react'
import { computeResults, DEFAULT_STATE } from '../_utils/calculator'
import type { CalculatorResults, CalculatorSetters, CalculatorState } from '../types'

export function useCalculator(): {
  state: CalculatorState
  setters: CalculatorSetters
  results: CalculatorResults
} {
  const [state, setState] = useState<CalculatorState>(DEFAULT_STATE)

  const setters = useMemo<CalculatorSetters>(
    () =>
      (Object.keys(DEFAULT_STATE) as Array<keyof CalculatorState>).reduce(
        (acc, key) => ({
          ...acc,
          [key]: (value: number) => setState((prev) => ({ ...prev, [key]: value })),
        }),
        {} as CalculatorSetters
      ),
    []
  )

  const results = useMemo(() => computeResults(state), [state])

  return { state, setters, results }
}
